import { useToggle } from 'react-use';
import { Common } from '@thecvlb/design-system/lib/src';

import FAQ from 'modals/FAQ';
import RadioGroup from 'shared/RadioGroup';

import { NotQualifiedProps } from './notQualified.types';

import wegovy from 'assets/images/other/wegovy.webp';

const NotQualified: React.FC<NotQualifiedProps> = ({
  onContinue,
  TTMonthlyPrice,
  userCurrentPPType
}) => {
  const isMaintenancePPType = userCurrentPPType === 'maintenance';

  const [isFAQOpen, toggleIsFAQOpen] = useToggle(false);

  const ITEMS = [
    ...(isMaintenancePPType
      ? []
      : [
          {
            label: (
              <div className="flex items-center justify-between">
                <div>
                  <p>Wegovy</p>
                  <p className="text-mSm">
                    <span className=" font-bold text-green">$499/mo</span>
                    <br />
                    <span className="text-gray">+ care subscription ($149/mo)</span>
                  </p>
                </div>
                <img alt="wegovy" className="-my-2.5 w-[52px] translate-y-2" src={wegovy} />
              </div>
            ),
            value: 'great-choice'
          }
        ]),
    {
      label: (
        <div>
          <p>Triple Therapy </p>
          <p className="text-mSm">
            <span className=" font-bold text-green">${TTMonthlyPrice}/mo</span>
            <br />
            <span className="text-gray">
              See if you qualify for Triple Therapy, a custom oral medication kit for weight loss
            </span>
          </p>
        </div>
      ),
      value: ''
    },
    {
      label: 'Review your answers',
      value: 'mif-info'
    }
  ];

  return (
    <>
      <FAQ
        isOpen={isFAQOpen}
        type="eligible"
        onClose={toggleIsFAQOpen}
        medication="semaglutide"
        screen="not-qualified-for-sema-plus"
      />
      <div className="flex h-full grow flex-col">
        <div className="flex flex-col gap-4 py-6">
          <div className="flex flex-col items-center gap-2 text-center">
            <h3 className="text-m2xl font-bold text-primary-700 md:text-2xl">
              You do not qualify for compounded semaglutide
            </h3>
            <p>
              Due to recent FDA announcements and corresponding changes in regulations, we can no
              longer prescribe you compounded semaglutide.
              <br />
              <b>Don’t worry, you still have good options:</b>
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <RadioGroup items={ITEMS} onSelect={onContinue} />
          </div>
        </div>
        <Common.Button
          className="max-md:mt-auto md:mx-auto"
          color="white-alt"
          fullWidthOnMobile
          onClick={toggleIsFAQOpen}
        >
          View FAQs
        </Common.Button>
        <Common.Button
          className="max-md:mt-auto md:mx-auto"
          style="text-only"
          fullWidthOnMobile
          onClick={() => onContinue('appointment')}
        >
          Discuss with my provider
        </Common.Button>
      </div>
    </>
  );
};

export default NotQualified;
